module.exports = __webpack_public_path__ + "img/call.57b5965d.svg";